export default "__VITE_ASSET__B2mV8GUD__"